import yup from '../yup';

export const registerSchema = yup.object().shape({
  name: yup.string()
    .nullable()
    .required('名前（姓）を入力してください')
    .label('surname'),
  surname: yup.string()
    .nullable()
    .required('名前（名）を入力してください')
    .label('name'),
  password: yup.string()
    .nullable()
    .required('パスワードを入力してください')
    .min(8, 'パスワードは8文字以上で入力してください')
    .matches(/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]+$/, 'パスワードは大文字・小文字・数字を含めてください')
    .label('password'),
  passwordConfirm: yup.string()
    .nullable()
    .required('パスワード確認を入力してください')
    .oneOf([yup.ref('password')], 'パスワードが一致しません')
    .label('passwordConfirm'),
  hasAgreedWithTerms: yup.boolean()
    .required('利用規約に同意してください')
    .label('hasAgreedWithTerms'),
});
